<template>
  <div class="rangk-wrap">
    <div class="item item-progress-wrap" v-for="item in list">
      <div class="label-wrap">
        <span class="name">{{ item.name }}</span>
        <!-- <span class="kc">{{ numberSplitWithComma(item.count) }}</span> -->
        <span class="kc">{{ item.count }}{{ item.dw||'' }}</span>
        <!-- <span class="percent">{{ item.sellRate }}%</span> -->
      </div>
      <CcProgress
        :style-wrap="{
          height: '6.6px',
          width: '100%',
          'background-color': 'rgba(0,0,0,0.1)'
        }"
        :color="'linear-gradient(90deg, #412DD0 0%, #2BD6F9 100%)'"
        :num="+item.rate"
        :show-progress-count="false"
      ></CcProgress>
    </div>
  </div>
</template>

<script>
import CcProgress from '@/components/DigitalMarketing/CcProgress'
import common from '@/mixins/common.js'
export default {
  mixins: [common],
  name: 'RangkWrap',
  props: [
    'list'
  ],
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {

  },
  components: {
    CcProgress
  }
}
</script>

<style scoped lang="stylus">
.rangk-wrap
  width 100%
  .item
    width 100%
    .label-wrap
      display: flex
      margin-bottom: 3px
  .kc
    color: #000
    font-size: 16px
    font-weight: 600
    margin-left: auto
  .name
    color: rgba(0, 0, 0, 1)
    font-size: 12px
    line-height 17px
  .item+.item
    margin-top 5px
</style>
